import { Switch } from "@headlessui/react"
import clsx from "clsx"
import Spinner from "./Spinner"
import useUser from "@/hooks/useUser"
import { router } from "@inertiajs/react"
import { useState } from "react"

const NotificationSettings = () => {
  const { user } = useUser()
  const enabled = user?.send_game_saved_email

  const [isProcessing, setIsProcessing] = useState(false)

  const handleToggle = (value: boolean) => {
    router.put(
      "/settings",
      { send_game_saved_email: value },
      {
        async: true,
        preserveScroll: true,
        preserveState: true,
        onStart: () => setIsProcessing(true),
        onFinish: () => setIsProcessing(false),
      }
    )
  }

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900">Notifications</h2>
      <div className="mt-3 space-y-5 overflow-hidden rounded-2xl border border-gray-100 bg-white px-4 py-5 shadow sm:px-6">
        <div className="flex items-center justify-between gap-x-4">
          <div className="text-sm font-medium text-balance text-gray-700">
            Send email with shareable link when a new game is saved
          </div>
          <Switch
            checked={enabled}
            disabled={isProcessing}
            onChange={handleToggle}
            className={clsx(
              "group focus:ring-chessdrop-600 relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition duration-200 ease-in-out focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed",
              enabled ? "bg-chessdrop-500" : "bg-gray-200"
            )}
          >
            <span className="sr-only">Toggle game saved email</span>
            <span
              aria-hidden="true"
              className={clsx(
                "pointer-events-none relative inline-flex h-5 w-5 transform items-center justify-center rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
                enabled && "translate-x-5"
              )}
            >
              {isProcessing ? (
                <Spinner size="xxs" className="text-gray-400" />
              ) : enabled ? (
                <svg
                  fill="currentColor"
                  viewBox="0 0 12 12"
                  className="text-chessdrop-600 h-3 w-3"
                >
                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
              ) : (
                <svg
                  fill="none"
                  viewBox="0 0 12 12"
                  className="h-3 w-3 text-gray-400"
                >
                  <path
                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
          </Switch>
        </div>
      </div>
    </div>
  )
}

export default NotificationSettings
